export default {"src":"/_next/static/media/credit_card_color.897ef4d8.svg","height":32,"width":32};